import { render, staticRenderFns } from "./PatientsFormInformationPopup.vue?vue&type=template&id=31a8861e&"
import script from "./PatientsFormInformationPopup.vue?vue&type=script&lang=js&"
export * from "./PatientsFormInformationPopup.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PatientsFormInformationPopup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports